import React from "react";
import { Link } from "react-router-dom"; // or use <a> if not using react-router
import { WifiOff } from "lucide-react";
import "./offline.css";

function OfflinePage() {
  return (
    <div className="offline-page">
      <div className="offline-card">
        <Link to="/" className="offline-logo">
          NinetyOne
        </Link>

        <div className="offline-icon-wrapper">
          <WifiOff className="offline-icon" aria-hidden="true" />
        </div>

        <h1 className="offline-title">No Connection</h1>
        <p className="offline-message">
          Your internet link seems to be offline. Check your network, then retry
          or head back to the store.
        </p>

        <div className="offline-actions">
          <button
            onClick={() => window.location.reload()}
            className="offline-btn offline-btn--primary"
          >
            Try Again
          </button>
          <Link to="/" className="offline-btn offline-btn--secondary">
            Back to Store
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OfflinePage;
